export default "__VITE_ASSET__BKKazpBA__"